export default "__VITE_ASSET__Dli0d6Yx__"